var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11, _path12, _path13, _g3, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _g6, _path19, _path20, _g7, _path21, _path22, _g8, _path23, _path24, _g9, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsmosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8397 10.6063C54.229 8.25428 52.2658 5.90225 48.732 3.28396C45.8963 1.1982 42.8861 0 40.4866 0C40.0066 0 39.5704 0.0443758 39.1341 0.133131C38.0434 0.355021 37.0837 1.15382 36.4729 2.35203C35.7312 3.77212 35.5567 5.68037 36.0367 6.8342C36.2112 7.18922 36.4293 7.633 36.6911 8.03239C34.3789 9.45249 33.07 9.85189 32.8955 9.89627C38.916 11.9376 43.9331 16.198 47.0743 21.7451L47.1179 21.2126C47.2488 19.7481 47.685 18.0618 48.2957 16.3311C48.9065 16.5086 49.5173 16.5973 50.1281 16.5973C51.7423 16.5973 53.1383 15.9317 54.0109 14.7335C54.8834 13.5352 55.2324 11.9377 54.8397 10.6063Z",
    fill: "#5E12A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.558 15.045C52.528 16.1543 54.1421 13.0479 53.6186 10.9622C53.0515 8.87639 51.2192 6.74625 47.9909 4.34985C44.7624 1.95344 41.4905 0.97713 39.3964 1.4209C37.3023 1.86468 36.6914 5.10427 37.2151 6.34685C37.4332 6.835 37.913 7.54505 38.5674 8.34385C37.7386 8.92076 36.9532 9.36454 36.2988 9.76395C40.3125 11.5834 43.8027 14.4236 46.4203 17.9738C46.7256 16.7757 47.1619 15.7106 47.5545 14.7786C47.8599 14.823 48.209 14.9117 48.558 15.045Z",
    fill: "url(#paint0_radial_1004_9297)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8249 58.5314C39.2936 58.5314 50.2122 47.4249 50.2122 33.7242C50.2122 20.0236 39.2936 8.91699 25.8249 8.91699C12.3561 8.91699 1.4375 20.0236 1.4375 33.7242C1.4375 47.4249 12.3561 58.5314 25.8249 58.5314Z",
    fill: "url(#paint1_radial_1004_9297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M51.6112 8.91945C48.2957 5.36922 45.5036 4.43728 42.1443 3.68286C39.5267 3.06157 40.2247 1.55273 43.4095 1.86337C41.8825 1.33083 40.4428 1.1977 39.3958 1.41959C37.3017 1.86337 36.6909 5.10295 37.2145 6.34554C37.4326 6.83369 37.9125 7.54374 38.5668 8.34254C37.389 9.14134 36.3855 9.71825 35.5566 10.162C35.9493 10.3395 36.4291 10.5614 36.9964 10.8721C38.4796 11.6709 40.0938 13.0022 40.0938 13.0022C37.6507 10.8721 38.1742 9.89576 41.5335 7.49935C42.5805 6.74493 44.5001 6.83369 46.2888 7.76562C48.0775 8.69756 50.1716 11.0496 50.1716 11.0496L48.1648 14.9549C48.2957 14.9993 48.4265 15.0436 48.5574 15.088C49.8226 15.443 50.826 15.3542 51.6112 15.0436C52.5275 14.4666 54.9269 12.514 51.6112 8.91945Z",
    fill: "#A98698"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1014 5.81402C42.974 6.16905 44.1082 6.79034 45.5043 7.72227C47.1621 8.83172 48.6017 10.0743 49.518 11.0506C47.991 13.0919 46.9875 15.8878 46.3768 17.8405C46.6821 18.2842 47.0311 18.728 47.3366 19.1717C47.642 18.0624 48.1655 16.4204 48.8635 14.7783C49.038 14.8228 49.2561 14.8228 49.4743 14.8228C49.9978 14.8228 50.6086 14.7339 51.0884 14.3345C51.4374 14.0683 51.8302 13.5802 51.7865 12.6926C51.7865 11.8494 51.1321 10.7844 49.7797 9.49739C48.8198 8.56545 47.5111 7.54476 46.2023 6.61283C42.4504 4.08329 39.8328 3.37324 38.6549 4.57144C37.8696 5.37024 37.9568 6.34656 38.2186 7.05661C36.8226 7.98854 35.6446 8.6542 34.8594 9.09798C35.3829 9.27549 35.8627 9.49739 36.3863 9.71928C37.7823 8.96486 39.7892 7.6779 42.1014 5.81402ZM50.3468 12.1601C50.4777 12.3819 50.5213 12.6038 50.5213 12.737C50.5213 13.1363 50.3904 13.2696 50.3032 13.3583C50.1287 13.4914 49.7797 13.5802 49.4743 13.5802C49.7361 13.0476 50.0415 12.6038 50.3468 12.1601ZM39.571 5.54776C39.7019 5.41463 40.0509 5.32586 40.6181 5.41463C40.1818 5.76964 39.7455 6.08029 39.3093 6.39093C39.2657 6.08029 39.3093 5.76964 39.571 5.54776Z",
    fill: "#5E12A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.827 7.45654C11.5611 7.45654 0 19.2166 0 33.7282C0 48.2398 11.5611 60 25.827 60C40.093 60 51.654 48.2398 51.654 33.7282C51.654 19.2166 40.0494 7.45654 25.827 7.45654ZM25.827 58.5355C12.3464 58.5355 1.43969 47.441 1.43969 33.7282C1.43969 20.0155 12.3464 8.921 25.827 8.921C39.3076 8.921 50.2143 20.0155 50.2143 33.7282C50.2143 47.441 39.264 58.5355 25.827 58.5355Z",
    fill: "#5E12A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.8249 58.5329C39.2936 58.5329 50.2122 47.4263 50.2122 33.7257C50.2122 20.0251 39.2936 8.91846 25.8249 8.91846C12.3561 8.91846 1.4375 20.0251 1.4375 33.7257C1.4375 47.4263 12.3561 58.5329 25.8249 58.5329Z",
    fill: "url(#paint2_linear_1004_9297)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.6514 55.517C12.3452 53.3425 3.31447 40.6061 5.49581 27.0709C6.4556 21.0798 9.42221 15.9763 13.6104 12.293C7.50263 15.8876 2.96546 22.1448 1.74391 29.7778C-0.3938 43.3131 8.63694 56.0496 21.8995 58.224C29.316 59.4666 36.4708 57.1147 41.7496 52.4993C37.0816 55.2507 31.4101 56.4489 25.6514 55.517Z",
    fill: "#A98698"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.7118 9.27517C23.5604 8.25448 17.5836 9.67458 12.6973 12.8254C12.6101 12.9142 12.5228 13.0029 12.5228 13.0029C14.3988 11.8491 17.1472 10.8284 17.1472 10.8284C10.0798 14.9999 7.89844 19.7483 7.89844 19.7483C10.6469 14.3343 18.7178 10.5178 25.0437 10.2515C31.3696 9.98522 35.5142 11.8935 40.5748 16.0206C45.6356 20.1922 48.6894 28.7126 48.3841 35.4581C48.1223 42.2035 44.6321 47.662 44.6321 47.662C47.0316 44.5112 48.4713 42.2035 49.3874 39.8516C49.5619 39.1414 49.7365 38.4315 49.8238 37.677C52.0051 24.1861 43.0179 11.4497 29.7118 9.27517Z",
    fill: "url(#paint3_linear_1004_9297)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9934 33.5049C48.9934 46.5076 38.6102 57.0696 25.8276 57.0696C13.0449 57.0696 2.61816 46.5076 2.61816 33.5049H48.9934Z",
    fill: "url(#paint4_linear_1004_9297)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.1617 33.5063C47.1617 46.1984 37.3021 56.5828 24.9121 57.0711C25.2175 57.0711 25.5228 57.0711 25.8282 57.0711C38.6109 57.0711 48.994 46.5091 48.994 33.5063H47.1617Z",
    fill: "url(#paint5_linear_1004_9297)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.89212 33.5063H2.62012C2.62012 46.5091 13.0033 57.0711 25.7859 57.0711C26.353 57.0711 26.8765 57.0711 27.4001 57.0267C15.4027 56.1391 5.89212 45.9321 5.89212 33.5063Z",
    fill: "url(#paint6_linear_1004_9297)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9498 33.7258C48.9498 31.0189 44.3252 29.4657 38.174 28.9331C33.7241 28.5781 29.2304 29.0218 24.0825 30.6194C19.6326 31.9508 15.6189 31.7289 12.696 31.3739C6.19555 30.6194 2.61816 30.5307 2.61816 33.7258C2.61816 38.3411 11.867 44.1103 25.7403 42.1133C32.7642 41.0926 36.3853 39.0069 40.5298 37.5868C45.0234 36.0779 48.9498 36.1223 48.9498 33.7258Z",
    fill: "url(#paint7_linear_1004_9297)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4186 22.5423C35.5871 22.5423 37.345 20.7541 37.345 18.5483C37.345 16.3424 35.5871 14.5542 33.4186 14.5542C31.2502 14.5542 29.4922 16.3424 29.4922 18.5483C29.4922 20.7541 31.2502 22.5423 33.4186 22.5423Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8317 25.5162C40.7473 25.5162 41.4895 24.7613 41.4895 23.8299C41.4895 22.8985 40.7473 22.1436 39.8317 22.1436C38.9161 22.1436 38.1738 22.8985 38.1738 23.8299C38.1738 24.7613 38.9161 25.5162 39.8317 25.5162Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.7689 15.3545C45.7253 15.3545 45.6817 15.3545 45.6817 15.3545C45.4198 15.3102 45.2453 15.0439 45.2889 14.7332C45.6817 12.6918 47.3394 10.7392 47.4266 10.6505C47.6012 10.4286 47.9502 10.4286 48.1247 10.6061C48.3429 10.7836 48.3429 11.1386 48.1684 11.3161C48.1247 11.3605 46.5978 13.18 46.2488 14.9551C46.2051 15.2214 45.987 15.3545 45.7689 15.3545Z",
    fill: "url(#paint8_linear_1004_9297)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.2167 52.2342C24.8913 52.2342 25.4382 51.6779 25.4382 50.9916C25.4382 50.3054 24.8913 49.749 24.2167 49.749C23.5421 49.749 22.9951 50.3054 22.9951 50.9916C22.9951 51.6779 23.5421 52.2342 24.2167 52.2342Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.5178 51.792C23.0379 51.3038 23.0379 50.505 23.5178 50.0169C23.605 49.9282 23.6923 49.8838 23.7795 49.7949C23.605 49.8394 23.4742 49.9282 23.3433 50.0613C22.8634 50.5494 22.8634 51.3482 23.3433 51.8364C23.7359 52.2358 24.3467 52.3245 24.8266 52.0583C24.3903 52.2358 23.8668 52.147 23.5178 51.792Z",
    fill: "url(#paint9_linear_1004_9297)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.6485 50.6345C24.793 50.6345 24.9102 50.5154 24.9102 50.3683C24.9102 50.2213 24.793 50.1021 24.6485 50.1021C24.5038 50.1021 24.3867 50.2213 24.3867 50.3683C24.3867 50.5154 24.5038 50.6345 24.6485 50.6345Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5849 51.611C31.2595 51.611 31.8064 51.0548 31.8064 50.3684C31.8064 49.6822 31.2595 49.126 30.5849 49.126C29.9103 49.126 29.3633 49.6822 29.3633 50.3684C29.3633 51.0548 29.9103 51.611 30.5849 51.611Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.8879 51.1728C29.408 50.6846 29.408 49.8858 29.8879 49.3977C29.9752 49.3089 30.0624 49.2645 30.1497 49.1758C29.9752 49.2202 29.8443 49.3089 29.7134 49.442C29.2335 49.9302 29.2335 50.729 29.7134 51.2171C30.106 51.6166 30.7168 51.7054 31.1968 51.439C30.7604 51.6166 30.2369 51.5278 29.8879 51.1728Z",
    fill: "url(#paint10_linear_1004_9297)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.0176 50.0195C31.1621 50.0195 31.2794 49.9002 31.2794 49.7532C31.2794 49.6061 31.1621 49.4868 31.0176 49.4868C30.873 49.4868 30.7559 49.6061 30.7559 49.7532C30.7559 49.9002 30.873 50.0195 31.0176 50.0195Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4415 54.4948C27.9475 54.4948 28.3576 54.0776 28.3576 53.5628C28.3576 53.0481 27.9475 52.6309 27.4415 52.6309C26.9355 52.6309 26.5254 53.0481 26.5254 53.5628C26.5254 54.0776 26.9355 54.4948 27.4415 54.4948Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.919 54.1407C26.57 53.7856 26.57 53.1644 26.919 52.8094C26.9626 52.765 27.0499 52.7206 27.0935 52.6763C26.9626 52.7206 26.8754 52.8094 26.7881 52.8981C26.4391 53.2531 26.4391 53.8744 26.7881 54.2295C27.0935 54.5401 27.5297 54.5845 27.9223 54.3626C27.5734 54.4957 27.1807 54.407 26.919 54.1407Z",
    fill: "url(#paint11_linear_1004_9297)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.7487 53.2526C27.8451 53.2526 27.9232 53.1731 27.9232 53.075C27.9232 52.977 27.8451 52.8975 27.7487 52.8975C27.6523 52.8975 27.5742 52.977 27.5742 53.075C27.5742 53.1731 27.6523 53.2526 27.7487 53.2526Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.0685 53.8318C33.5744 53.8318 33.9847 53.4145 33.9847 52.8998C33.9847 52.385 33.5744 51.9678 33.0685 51.9678C32.5625 51.9678 32.1523 52.385 32.1523 52.8998C32.1523 53.4145 32.5625 53.8318 33.0685 53.8318Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.543 53.4756C32.194 53.1206 32.194 52.4993 32.543 52.1444C32.5866 52.1 32.6739 52.0556 32.7175 52.0112C32.5866 52.0556 32.4994 52.1444 32.4121 52.2331C32.0631 52.5881 32.0631 53.2093 32.4121 53.5645C32.7175 53.8751 33.1538 53.9194 33.5464 53.6976C33.1974 53.8307 32.8048 53.7419 32.543 53.4756Z",
    fill: "url(#paint12_linear_1004_9297)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3737 52.5889C33.4701 52.5889 33.5482 52.5095 33.5482 52.4114C33.5482 52.3134 33.4701 52.2339 33.3737 52.2339C33.2773 52.2339 33.1992 52.3134 33.1992 52.4114C33.1992 52.5095 33.2773 52.5889 33.3737 52.5889Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.0215 51.7913C20.1297 51.7913 21.0282 50.8773 21.0282 49.75C21.0282 48.6225 20.1297 47.7085 19.0215 47.7085C17.9131 47.7085 17.0146 48.6225 17.0146 49.75C17.0146 50.8773 17.9131 51.7913 19.0215 51.7913Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.8888 51.0365C17.1035 50.2377 17.1035 48.9507 17.8888 48.1519C18.0196 48.0188 18.1505 47.9301 18.325 47.8413C18.0633 47.9301 17.8451 48.1076 17.627 48.2851C16.8418 49.0839 16.8418 50.3708 17.627 51.1696C18.2814 51.8353 19.2849 51.9684 20.0701 51.4803C19.3285 51.7909 18.4559 51.6578 17.8888 51.0365Z",
    fill: "url(#paint13_linear_1004_9297)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.7224 49.1239C19.9632 49.1239 20.1586 48.9252 20.1586 48.6801C20.1586 48.4349 19.9632 48.2363 19.7224 48.2363C19.4814 48.2363 19.2861 48.4349 19.2861 48.6801C19.2861 48.9252 19.4814 49.1239 19.7224 49.1239Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.953 46.7771C38.0614 46.7771 38.9598 45.8632 38.9598 44.7357C38.9598 43.6083 38.0614 42.6943 36.953 42.6943C35.8448 42.6943 34.9463 43.6083 34.9463 44.7357C34.9463 45.8632 35.8448 46.7771 36.953 46.7771Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.7736 46.017C34.9883 45.2181 34.9883 43.9311 35.7736 43.1324C35.9045 42.9993 36.0354 42.9105 36.2099 42.8218C35.9481 42.9105 35.73 43.088 35.5119 43.2655C34.7265 44.0643 34.7265 45.3512 35.5119 46.1501C36.1662 46.8157 37.1696 46.9488 37.9549 46.4607C37.2132 46.7713 36.3844 46.6382 35.7736 46.017Z",
    fill: "url(#paint14_linear_1004_9297)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.6482 44.1072C37.8891 44.1072 38.0845 43.9086 38.0845 43.6635C38.0845 43.4183 37.8891 43.2197 37.6482 43.2197C37.4073 43.2197 37.2119 43.4183 37.2119 43.6635C37.2119 43.9086 37.4073 44.1072 37.6482 44.1072Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1004_9297",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8229 8.1663) scale(19.4987 19.8344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1004_9297",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9713 16.6217) scale(47.7062 48.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1004_9297",
    x1: 21.913,
    y1: 58.181,
    x2: 29.9771,
    y2: 9.27273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1004_9297",
    x1: 43.0159,
    y1: 16.88,
    x2: 22.5355,
    y2: 35.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1004_9297",
    x1: 2.63779,
    y1: 45.2734,
    x2: 48.9822,
    y2: 45.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0002E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FF00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1004_9297",
    x1: 51.1766,
    y1: 35.5741,
    x2: 25.5457,
    y2: 59.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1004_9297",
    x1: 2.63974,
    y1: 45.2749,
    x2: 27.4338,
    y2: 45.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#7D00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1004_9297",
    x1: 2.6689,
    y1: 35.6836,
    x2: 48.951,
    y2: 35.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#BE00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1004_9297",
    x1: 48.1955,
    y1: 10.4343,
    x2: 44.7862,
    y2: 15.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1004_9297",
    x1: 22.9822,
    y1: 51.0313,
    x2: 24.8279,
    y2: 51.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1004_9297",
    x1: 29.3478,
    y1: 50.4036,
    x2: 31.1936,
    y2: 50.4036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1004_9297",
    x1: 26.5206,
    y1: 53.5744,
    x2: 27.9063,
    y2: 53.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1004_9297",
    x1: 32.1258,
    y1: 52.9076,
    x2: 33.5115,
    y2: 52.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1004_9297",
    x1: 17.018,
    y1: 49.8015,
    x2: 20.0323,
    y2: 49.8015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1004_9297",
    x1: 34.9195,
    y1: 44.7805,
    x2: 37.9339,
    y2: 44.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmosis);
export default __webpack_public_path__ + "static/media/osmosis.edb3e7c958b65b897d3263e02939e182.svg";
export { ForwardRef as ReactComponent };